import React from "react";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

function XLSX(props) {
    const { columns, data } = props
    const _columns = Array.isArray(columns) ? columns : columns.map(col => col.text || "")

    const _data = data.map(row => {
        const _row = []
        for (const _col of _columns) {
            _row.push(row[_col] ?? "")
        }
        return _row
    })
    return (
        <ExcelFile element={props.children} filename={props.name}>
            <ExcelSheet dataSet={[{
                columns: _columns,
                data: _data,
            }]} name={props.name} />
        </ExcelFile>
    );

}
export default XLSX